import { Box, Paper, styled } from "@mui/material"
import { useMemo } from "react"

type navigationProps = {
  data: {
    label: string
    value: any
  }[]
}

export const DashboardWrapper = styled(Box)({
  display: "flex",
  flexGrow: 1,
  flexDirection: "column",
  height: "100%",
  backgroundColor: "#F8F9FA",
})

export const DashboardPaper = styled(Paper)({
  // border: "1px solid red",
  margin: "0px 24px",
  display: "flex",
  flexDirection: "column",
  borderRadius: "4px",
  boxShadow: "0px 2px 8px #00000022",
  // height: "90vh",
  // backgroundColor: "#f7f7f7",
  // padding: "20px"
  height: "78vh",
})

export const NavigationAssistant = ({ data }: navigationProps) => {
  const message = useMemo(() => {
    let message = "Select filters"
    for (let item of data) {
      if (!item.value) {
        return item.label
      }
    }
    return message
  }, [data])

  return (
    <DashboardPaper
      sx={{ mb: "10px", justifyContent: "center", alignItems: "center" }}
    >
      {message}
    </DashboardPaper>
  )
}
